import React from 'react';
import { graphql } from 'gatsby';
import { Section } from '../../../section';
import { NestedComponentRenderer } from '../../NestedComponentRenderer';
import { StyledItem } from '../../../tickList/TickList';

export const WideSection = ({
  data: { background, components, wideSectionId },
  ...rest
}) => {
  const nestedComponents = components.map((item) => {
    const { component } = item;

    return {
      ...component,
      areas: item.areas,
    };
  });

  return (
    <Section
      background={background === 'Background'}
      id={wideSectionId}
      {...rest}
    >
      <NestedComponentRenderer components={nestedComponents} />
    </Section>
  );
};

export const WideSectionQuery = graphql`
  fragment WideSection on UMBRACO_WideSectionComponentType {
    background
    wideSectionId
    components {
      remoteTypeName
      component {
        ...Accordion
        ...NestedComponents
      }
      areas {
        blockGridItems {
          component {
            ...Accordion
            ...NestedComponents
          }
        }
      }
    }
  }
`;
